export default __webpack_public_path__ + "static/media/section3_2.1831f77f.png";